import { MenuItem, MenuItemType } from "@/client";
import i18n from "@/i18n";

import { ContentNavigationItemForm } from "./content-navigation-item-form";
import { CustomUrlNavigationItemForm } from "./custom-url-navigation-item-form";
import { NoDataNavigationItemForm } from "./no-data-navigation-item-form";
import { UrlNavigationItemForm } from "./url-navigation-item-form";

export function renderNavigationItemForm({
  menuId,
  menuItemType,
  menuItem,
  onClose,
}: {
  menuId: string;
  menuItemType: MenuItemType;
  onClose: () => void;
  menuItem?: MenuItem;
}) {
  switch (menuItemType) {
    case MenuItemType.MY_SCHEDULE:
    case MenuItemType.NEWS:
    case MenuItemType.NOTES:
    case MenuItemType.NOW:
    case MenuItemType.PEOPLE:
    case MenuItemType.SCHEDULE:
    case MenuItemType.SEARCH:
      return menuItem ? (
        <NoDataNavigationItemForm initialData={menuItem} onClose={onClose} />
      ) : (
        <NoDataNavigationItemForm
          menuId={menuId}
          menuItemType={menuItemType}
          onClose={onClose}
        />
      );

    case MenuItemType.LINK:
      return menuItem ? (
        <UrlNavigationItemForm initialData={menuItem} onClose={onClose} />
      ) : (
        <UrlNavigationItemForm
          menuId={menuId}
          menuItemType={menuItemType}
          onClose={onClose}
        />
      );
    case MenuItemType.CUSTOMIZED_PAGE:
      return menuItem ? (
        <CustomUrlNavigationItemForm initialData={menuItem} onClose={onClose} />
      ) : (
        <CustomUrlNavigationItemForm
          menuId={menuId}
          menuItemType={menuItemType}
          onClose={onClose}
        />
      );
    case MenuItemType.CONTENT:
      return menuItem ? (
        <ContentNavigationItemForm initialData={menuItem} onClose={onClose} />
      ) : (
        <ContentNavigationItemForm
          menuId={menuId}
          menuItemType={menuItemType}
          onClose={onClose}
        />
      );
    default:
      return <p>{i18n.t("common.error")}</p>;
  }
}
